import React from 'react';
import { ResponsiveLine } from '@nivo/line';

const LineGraph = ({ data }) => {
  const lowestValue = JSON.parse(JSON.stringify(data[0].data)).sort(
    (a, b) => a.y - b.y,
  )[0].y;
  const SIGF = 1000000;
  return (
    <ResponsiveLine
      data={data}
      theme={{ fontFamily: 'Inter' } as any}
      margin={{ top: 0, right: 20, bottom: 55, left: 50 }}
      enableGridX={true}
      enableGridY={false}
      enableCrosshair={false}
      isInteractive={true}
      enableArea={true}
      enablePoints={true}
      lineWidth={1}
      pointSize={0}
      useMesh={true}
      areaOpacity={0.8}
      colors={() => '#106DA1'}
      // @ts-ignore
      areaBaselineValue={lowestValue}
      yScale={{
        type: 'linear',
        min: 'auto',
        max: 'auto',
        stacked: false,
        reverse: false,
      }}
      curve="monotoneX"
      axisTop={null}
      axisRight={null}
      xScale={{
        type: 'time',
        format: '%Y-%m-%d',
        precision: 'day',
      }}
      xFormat="time:%Y-%m-%d"
      axisBottom={{
        format: '%b %y',
        orient: 'bottom',
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 90,
        tickValues: 'every month',
        // legend: 'Date',
        // legendOffset: 40,
        // legendPosition: 'middle',
      }}
      axisLeft={{
        orient: 'left',
        tickSize: 5,
        tickPadding: 3,
        tickRotation: 0,
        format: (v) => '£' + Number(v) / SIGF + 'm',
        // legend: 'GBP Balance',
        // legendOffset: -55,
        legendPosition: 'middle',
      }}
      tooltip={(props) => (
        <div className="px-2 py-1 text-xs text-white rounded bg-jcap-700">
          £{(Number(props.point.data.y) / SIGF).toFixed(1)}m
        </div>
      )}
    />
  );
};

export default LineGraph;
